import type { QueuedPhotoEntry } from './photoQueueStorage'

/**
 * Single owner of the queued-vs-server merge rule: entries for this order
 * whose clientId the server list does not contain yet (a server photo with
 * the same clientId wins — that upload already landed).
 */
export function entriesForOrder(
  entries: QueuedPhotoEntry[],
  orderId: number,
  serverPhotos: ReadonlyArray<{ clientId: string }>,
): QueuedPhotoEntry[] {
  return entries.filter(
    (entry) =>
      entry.orderId === orderId &&
      !serverPhotos.some((photo) => photo.clientId === entry.clientId),
  )
}
